<template>
  <div
    class="mt-[50px] grid min-h-[51vh] px-[28px] pb-[150px] font-avuText text-avu-black lg:grid-cols-[20vw,30vw] lg:pl-[67px]"
  >
    <div>
      <slot name="left" />
    </div>
    <div>
      <slot name="right" />
    </div>
  </div>
</template>

<script setup></script>
